import { render, staticRenderFns } from "./DirectDebit.vue?vue&type=template&id=00fafd78&"
import script from "./DirectDebit.vue?vue&type=script&lang=js&"
export * from "./DirectDebit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports